import { useLocation } from 'react-router-dom';

import { useStyles } from './styles';
import { quizzesWithoutSkip } from 'types/quiz';
import { PATH } from 'routes/constant';
import { STRINGS } from '../../constants';

export default function SkipQuiz(props) {
    const classes = useStyles();
    const { quizId, handleSkipOpen } = props;
    const location = useLocation();

    return !quizzesWithoutSkip.includes(quizId) && location.pathname.includes(PATH.QUIZ_MANAGER) ? (
        <div
            className={classes.buttonContinue}
            onClick={() => {
                handleSkipOpen();
            }}
        >
            {STRINGS.SKIP}
        </div>
    ) : null;
}
